export default {
    methods: {
        weekCalcs() {

            return {
                sub: (minuendo, subtraendo) => {

                    const result = minuendo - subtraendo

                    return Math.sign(result) === 0 || Math.sign(result) === -1
                        ? 7 - Math.abs(result) : result
                },
                sum: (parcela1, parcela2) => {

                    const result = parcela1 + parcela2

                    return result > 7 ? result - 7 : result
                }
            }
        }
    }
}